module.exports = __webpack_public_path__ + "c6da8f13c9af11c64c399a3aa81ae57e.svg";